module.exports = __webpack_public_path__ + "static/media/cts_image1.32beeb96.png";